import { render, staticRenderFns } from "./MarginTop.vue?vue&type=template&id=0e126e48&"
import script from "./MarginTop.vue?vue&type=script&lang=js&"
export * from "./MarginTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports